import { useState } from "react";

/**
 * One Autopilot call at a time for a row or form: busy while it runs, then the notice
 * passed in, or the error's message. `onDone` runs after a call succeeds.
 */
const useAsyncAction = (onDone) => {
  const [isBusy, setIsBusy] = useState(false);
  const [notice, setNotice] = useState("");

  const run = async (action, doneNotice = "") => {
    setIsBusy(true);
    setNotice("");
    try {
      await action();
      setNotice(doneNotice);
      onDone?.();
    } catch (actionError) {
      setNotice(actionError.message);
    } finally {
      setIsBusy(false);
    }
  };

  return { isBusy, notice, run };
};

export default useAsyncAction;
